import Tooltip from "PFComponents/tooltip/tooltip";
import SearchFatIcon from "PFIcons/search_fat.svg";
import PropTypes from "prop-types";
import React from "react";

import { getExceptionFromRole, getExceptionType } from "./helpers";
import css from "./type_tooltip_icon.module.scss";

const TypeTooltipIcon = ({ role }) => {
  const exception = getExceptionFromRole(role);
  if (!exception) {
    return null;
  }
  return (
    <Tooltip content={getExceptionType(exception?.exceptions)}>
      <span>
        <SearchFatIcon width={20} height={20} viewBox="0 0 20 20" className={css.icon} />
      </span>
    </Tooltip>
  );
};

TypeTooltipIcon.propTypes = {
  role: PropTypes.object.isRequired
};

export default TypeTooltipIcon;
